export default {
  pageTitle: '包裹信息',
  waybill: '打印面单',
  waybillNumber: '国内运单号',
  logisticsCompany: '物流公司',
  shoInformation: '发运单信息',
  receiver: '收件人信息',
  fromWarehouse: '发货仓',
  already: '已于',
  successSubmit: '提交交付完成',
  startShipment: '开始国内发货',
  placeholder1: '国内运单号',
  parcelDelivery: '请将包裹发送到指定中转仓',
  location: '所在地',
  transitName: '中转仓名称',
  person: '联系人',
  contactNumber: '联系电话',
  address: '收货地址',
  tips1: '请先将订单点击为开始发货，然后待订单包裹准备好后再开始本地派送。',
  startShipping: '开始发货',
  cancelShppidOrder: '取消此已发货订单',
  cancelOrder: '取消此已确认订单',
  cancelStock: '因无库存而取消',
  cancelOrder2: '取消订单',
  addNumber: '添加国际物流单号',
  application: '订单交付完成申请',
  successd: '订单已交付完成',
  startDelivery: '开始本地派送',
  tips2: '请输入本地物流运单号',
  closeOrder: '关闭订单',
  goodsDamaged: '商品损坏',
  goodsNotInApp: '商品与描述不符',
  customerNoReason: '用户无理由拒收',
  packageRealStatus: '包裹实际状态',
  customerRejected: '用户拒收',
  customerAcceptedPackage: '用户签收',
  noLogisticsRecord: '无物流记录',
  cancelConfirmation: '取消确认',
  tips3: '订单将被取消，您确实要执行吗？',
  content1: '请选择要使用的尾程快递公司',
  content2: '请选择要使用的尾程快递公司',
  content3: '系统已经根据城市的配送情况做了默认配置，一般情况下无需更改，特殊情况下请手动指定快递服务商',
  type1: 'eCourier',
  type2: 'E-Desh (manually)',
  type3: '自配送',
  cod: '货到付款',
  mpay: '在线支付',
  startEnter: '开始填写面单',
  so: '订单ID',
  count: '数量',
  package: '包裹id',
  tips4: '此地址在系统中找不到',
  type4: 'E-Desh NO.', // TODO【孟加拉的尾程物流edash的包裹号，这里不需翻译，应替换成日本物流相应的】
  remarks: '备注',
  // -----------------------------
  realStatus1: '已发货',
  realStatus2: '派送中',
  realStatus3: '已送达',
  // -----------------------------
  orderconditions1: '中通',
  orderconditions2: '圆通',
  orderconditions3: '申通',
  orderconditions4: '韵达',
  orderconditions5: '百世',
  orderconditions6: '人人',
  orderconditions7: '顺丰',
  orderconditions8: '京东',
  orderconditions9: '其他',
  // --------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // ------------------
  paymentMethodMap1: '在线支付',
  paymentMethodMap2: '货到付款',
  paymentMethodMap3: '预付款',
  // -----------------注：原文中确有两个In Delivery
  packageStatusMap1: '待发货',
  packageStatusMap2: '运输中',
  packageStatusMap3: '派送中',
  packageStatusMap4: '已完成',
  packageStatusMap5: '派送中',
  packageStatusMap6: '取消',
  packageStatusMap7: '已拒收',
  packageStatusMap8: '已退回',
  // ---------------
  shipOrderStatusMap1: '拣货',
  shipOrderStatusMap2: '拣货完成',
  shipOrderStatusMap3: '打包完成',
  // -------------
  columnSHO1: '订单ID',
  columnSHO2: '发运单',
  columnSHO3: '货品',
  columnSHO4: '金额',
  columnSHO5: '状态',
  columnSHO6: '卖家发货时间',
  columnSHO7: '打包完成时间',
  // -----------------
  columnReceipt1: '用户ID',
  columnReceipt2: '国别',
  columnReceipt3: '省份',
  columnReceipt4: '城市',
  columnReceipt5: '区域',
  columnReceipt6: '地址',
  columnReceipt7: '收件人',
  columnReceipt8: '联系电话',
  // -----------------
  tableColumnSku1: 'SKU#',
  tableColumnSku2: '供应商商品ID',
  tableColumnSku3: '标题',
  tableColumnSku4: '规格',
  tableColumnSku5: '价格',
  tableColumnSku6: '折扣',
  tableColumnSku7: '数量',
  tableColumnSku8: '小计',
  tableColumnSku9: '重量',
  // -----------------
  columnShipPackage1: '发运包ID',
  columnShipPackage2: '支付方式',
  columnShipPackage3: '较早的发运单创建时间',
  columnShipPackage4: '用户ID',
  columnShipPackage5: '支付余量',
  columnShipPackage6: '在线支付',
  columnShipPackage7: '前一个状态',
  columnShipPackage8: '状态',
  columnShipPackage9: '创建时间',
  columnShipPackage10: '打印时间',
  columnShipPackage11: '派送时间',
  columnShipPackage12: '关闭时间',
  columnShipPackage13: '物流单号',
  reason1: '损坏',
  reason2: '不符',
  reason3: '无理由',
  print: '打印',
  // -------------
  columnSku1: 'SKU#',
  columnSku2: '标题',
  columnSku3: '规格',
  columnSku4: '价格',
  columnSku5: '数量',
  columnSku6: '小计',
  columnSku7: '重量',
  // ----------------------
  send1: '【2204】SMS已关闭',
  send2: '【2252】SMS发送失败',
  errorTips1: '该商品从Dhaka退货仓发货，由Kilimall代处理',
  content_delivered1: '商品配送由',
  content_delivered2: '店铺自发货订单',
  content_delivered3: '平台承运',
  warningTips1: '请先在店铺设置中配置好发货地址',
  content4: '请选择快递！',
  content5: '请填写快递单号！',
  success1: '成功!',
  content6: '请确认订单已自行或通过快递交付用户手中再执行此操作！',
  content7: '处理中，请稍后再试',
  errorTips: '备注信息不能超过20个字符！',
  // TODO 请输入【这里是孟加拉的尾程物流edash的包裹号，应替换成日本物流相应的】物流单号
  content8: '请输入 E-Desh 物流单号',
  content9: '请输入正确的值',
  // -------------------------------------------------------------------
  // -------------------------------------------------------------------
  // 因命名时未考虑同名文件翻译不好处理 所有存在同名文件，现将其他名为_id的文件翻译也录在此处
  // fault-lisclaimer-list/_id.vue
  fl_pageTitle: 'Negligent record',
  fl_negligentRecordID: '过失记录ID',
  fl_punishID: '处罚ID',
  fl_all: 'All',
  fl_metaTitle: '过失与免责',
  fl_disclaimer: 'disclaimer',
  fl_deductionMargin: 'deductionMargin',
  fl_deduction: 'deductionInClearing',
  fl_recordID: '记录ID',
  fl_recordDate: '过失日期',
  fl_faultItem: '过失项',
  fl_faultName: '过失名',
  fl_faultDescription: '过失描述',
  fl_so: '源SO#',
  fl_punish: '处罚',
  fl_punishType: '处罚类型',
  fl_punishAcount: '处罚金额',
  // page-components\seller-center\marginrecord\negligent-record-detail.vue 为此页面组件 也暂时写在此处
  flc_title: 'Penalty details',
  flc_penaltyID: 'Penalty ID',
  flc_punishType: 'Type of punishment',
  flc_penaltyAmount: 'Penalty amount',
  flc_rmb: 'RMB',
  flc_relatedRecords: 'Related records',
  flc_originalOrder: 'Original order',
  flc_shop: 'Shop',
  // 卖家取消订单
  sle_selectcancel: '请选择或输入取消原因',
  sle_understock: '库存不足',
  sle_holidays: '节假日无法发货',
  sle_else: '其他',
  sle_reason: '请输入取消原因',
  sle_hint: '取消订单将产生过失，可能会引发保证金扣款，请谨慎处理。如果是用户不想要了，请联系统用户尽可能让对方发起取消操作',
  cal_cancalShppid: '取消已发货订单将产生过失和处罚，您要继续吗',
  cal_confirm: '确定',
  cal_confirmCancel: '取消',
  LogisticsNumber: '物流端运单号'
}
